import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { useHistory } from "react-router-dom";
import ProgressBar from "@hig/progress-bar";
import App from "../App";

// Forge OAuth configuration
// https://forge.autodesk.com/myapps/prism/view
const OAUTH_URL = "https://developer.api.autodesk.com/authentication/v2/authorize";
// https://aps.autodesk.com/myapps/9bf4ab23-c3ef-4cc7-9972-8b63b553e36b/
const CLIENT_ID = "SkkJ4zWJkfsEZAbhnsg0nLpzcUa1IGqGYU5EvsTYy8DuoMI9";
const CLIENT_SECRET = "hIyBbu5AD1clLI8CVj1l2Xbc9fOtDmsEb76yWbfvHC9b5A3WdxVCorAplkvQ14g1";
const redirectUrl = `${window.location.origin}`;

export function isValidToken(token) {
  if (!token) return false;
  try {
    const decoded = jwt_decode(token);
    // decoded.exp is token expiration date in seconds
    if (decoded.exp > Date.now() / 1000) {// token is not expired
      // token is not expired
      return true;
    } else {
      console.error('isValidToken() token expired:', decoded);
      return false;
    }
  } catch (error) {
    console.error('isValidToken() generic error:', error);
    return false;
  }
}

function hasUrlToken() {
  console.log('useEffect::hasUrlToken()');
  // Retrieve token from URL Fragment (#)
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");
  let valid = false;
  console.log('useEffect::hasUrlToken() code:', code);
  // Get a 3-Legged Token with Authorization Code Grant (https://aps.autodesk.com/en/docs/oauth/v2/tutorials/get-3-legged-token/)
  console.log('isValidToken() fetch jwt token ...');
  fetch("https://developer.api.autodesk.com/authentication/v2/token", {
    method: "POST",
    headers: {
      "Content-type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      'code': code,
      'client_id': CLIENT_ID,
      'client_secret': CLIENT_SECRET,
      'redirect_uri': redirectUrl,
      'grant_type': 'authorization_code'
    }).toString(),
  })
  .then(response => response.json())
  .then(data => {
    if ( data.access_token && data.token_type === 'Bearer' ) {
      const token = data.access_token;
      if (isValidToken(token)) {
        // Store token on browser local storage
        localStorage.setItem("adsk_prism_token", token);
        valid = true;
      }
    } else {
      console.error('isValidToken() fetch data is invalid:', data);
    }
  })
  .catch(error => {
    console.error('isValidToken() fetch error:', error);
  });
  if (valid) {
    return true;
  }
  // Store the search URL param (?/d or s) on browser local storage so we can go back to the original URL
  const searchParams = window.location.search;
  localStorage.setItem("adsk_prism_url_param", searchParams);
  return false;
}

function hasLocalToken() {
  console.log('useEffect::hasLocalToken()');
  // Retrieve token from browser local storage
  const token = localStorage.getItem("adsk_prism_token");
  return isValidToken(token);
}

function ProtectedRoute() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);

  const login = () => {
    // Redirect to Forge OAuth endpoint
    const apiUrl = new URL(OAUTH_URL);
    apiUrl.searchParams.append("response_type", "code");
    apiUrl.searchParams.append("scope", "data:read");
    apiUrl.searchParams.append("client_id", CLIENT_ID);
    apiUrl.searchParams.append("redirect_uri", redirectUrl);
    //apiUrl.searchParams.append("state", "authorize");
    window.location.href = apiUrl.href;
    console.log('login::Redirecting to:', apiUrl.href);
  };

  useEffect(() => {
    // Try to find a valid token on the URL, else try local storage
    if (hasUrlToken()) {
      // Clear token from URL
      const searchParams = localStorage.getItem("adsk_prism_url_param");
      if (searchParams) {
        history.replace(searchParams);
      } else {
        history.replace("#");
      }
      setIsLoading(false);
    } else if (hasLocalToken()) {
      console.log('useEffect::hasLocalToken()');
      setIsLoading(false);
    } else {
      login();
    }
  }, []);

  if (isLoading) {
    return <ProgressBar />;
  }

  return <App />;
}

export default ProtectedRoute;
